export const ENV = {
    appBaseUrl: process.env.REACT_APP_BASE_ADMIN_API,
    siteKey:process.env.SITE_KEY,
    appClientUrl: process.env.REACT_APP_BASE_URL,
    serverUrl: process.env.REACT_APP_SERVER_URL,
    Authorization: `Bearer ${process.env.REACT_APP_AUTHORIZATION}`,
    x_access_token: JSON.parse(localStorage.getItem('clientToken')),
    x_auth_token: process.env.REACT_APP_X_AUTH_TOKEN,
    adminPrivateKey: process.env.REACT_APP_ADMIN_PRIVATE_KEY,
    file_Url: process.env.REACT_APP_BACKEND_FILE_URL,
    appPageInsightsUrl: process.env.REACT_APP_BASE_API_PAGEINSIGHTS,

    encryptUserData(data, token, id) {
        if (data) {
            localStorage.setItem('client', JSON.stringify(data));
            localStorage.setItem('clientId', JSON.stringify(id));
        }
        if (token) {
            localStorage.setItem('clientToken', JSON.stringify(token));
        }
        return true;
    },
    getUserKeys(keys = null) {
        const userData = JSON.parse(localStorage.getItem('client'));
        return userData;
    },
    getToken() {
        const userData = localStorage.getItem('clientToken');
        if (userData) {
            return userData;
        }
        return {};
    },

    logout() {
        localStorage.removeItem('clientToken');
        localStorage.removeItem('client');
        localStorage.removeItem('clientId');
    },
    objectToQueryString(body) {
        const qs = Object.keys(body)
            .map((key) => `${key}=${body[key]}`)
            .join('&');
        return qs;
    },
};
